import { z } from "zod"

/** Header-injection guard: no CR, LF or NUL in a value that can reach a mail header. */
const singleLine = (max: number) =>
  z
    .string()
    .trim()
    .min(1, "Required")
    .max(max, `Use at most ${max} characters`)
    // oxlint-disable-next-line no-control-regex
    .refine((v) => !/[\u0000\r\n]/.test(v), "Remove line breaks")

export const MESSAGE_MAX = 5000
/** A human needs longer than this to fill the form; faster posts are bots. */
export const MIN_FILL_MS = 3000

export const contactFormSchema = z.strictObject({
  name: singleLine(100),
  email: singleLine(254).pipe(z.email("Enter a valid email address")),
  message: z
    .string()
    .trim()
    .min(10, "Write at least 10 characters")
    .max(MESSAGE_MAX, `Use at most ${MESSAGE_MAX} characters`),
  /** Honeypot: hidden from people, so only bots fill it. Not named like an autofill target. */
  hp_k7x2: z.string().max(500).optional(),
  /** Milliseconds the form was open, measured by the browser's own clock (no clock skew). */
  fillMs: z
    .string()
    .regex(/^\d{1,16}$/)
    .optional(),
  "cf-turnstile-response": z.string().max(4096).optional(),
})

export type ContactFormInput = z.infer<typeof contactFormSchema>
